import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { truncateJobName } from '../../utils/vinExtraction';
import { monoTextStyle } from './vinExtractionStyles';
import NoValue from './NoValue';

const BatchJobName = ({ jobName }) => {
    const { t } = useTranslation('vinExtraction');

    if (!jobName) return <NoValue label={t('batches.noJob')} />;

    return (
        <Typography.Text
            title={jobName}
            style={monoTextStyle}
            copyable={{ text: jobName, tooltips: [t('batches.copyJob'), t('batches.copiedJob')] }}
        >
            {truncateJobName(jobName)}
        </Typography.Text>
    );
};

export default BatchJobName;
